"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Row__Wrapper",
  componentId: "sc-y0xei6-0"
})(["display:flex;flex-wrap:wrap;justify-content:", ";align-items:", ";margin:0 -10px;"], function (props) {
  return props.justifyContent ? props.justifyContent : null;
}, function (props) {
  return props.alignItems ? props.alignItems : null;
});

var Row = function Row(_ref) {
  var className = _ref.className,
      children = _ref.children,
      justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems,
      tight = _ref.tight;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    justifyContent: justifyContent,
    alignItems: alignItems,
    tight: tight
  }, children);
};

var _default = Row;
exports.default = _default;